import React, {FC} from 'react';
import styled from 'styled-components';

import {AnalyticsPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ReportHeaderChatbotFilters} from './chatbotReportHeaderFilters';
import {ChatbotReportHeaderTitleRow} from './chatbotReportHeaderTitleRow';

/*
 * Props.
 */

interface ChatbotReportHeaderProps {
  panelId: AnalyticsPanelId;
}

/*
 * Styles.
 */

const StyledHeaderWrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;

  > div {
    padding: 0 48px;
  }
`;

/*
 * Component.
 */

export const ChatbotReportHeader: FC<ChatbotReportHeaderProps> = ({panelId}) => (
  <StyledHeaderWrapper>
    <ChatbotReportHeaderTitleRow />

    <ReportHeaderChatbotFilters panelId={panelId} />
  </StyledHeaderWrapper>
);
